import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import moment from 'moment'
import RestrictableButton from '../../../shared/components/Instructor/RestrictableButton'
import CustomProgressBar from '../../../shared/components/CustomProgressBar'

import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import panelStyle from 'Styles/panel.css'
import progressBarStyle from 'Styles/progress-bar.css'
import style from './style.css'

// Component for the progress area for the student start screen
function ProgressArea (props) {
  const { activityScore, scoreTarget, completedTimestamp, courseAvgTime, courseEstTime, ffEstimatedTimeToCompleteEnabled, openHowIsCalculatedModal } = props
  const completedActivity = activityScore >= scoreTarget
  // const progressBarLabel = `You currently have ${activityScore} points out of a target total of ${scoreTarget} points.`
  return (
    <div data-test-id="progressArea" className={classnames(panelStyle.large)}>
      <h2 className={style.targetScoreHeader}>Target Score Progress</h2>
      <p className={style.targetScoreLabel}>You have:</p>
      <Row>
        <Col sm={10} xs={10}>
          <CustomProgressBar
            dataTestId="progressBar"
            now={activityScore}
            min={0}
            max={scoreTarget}
            ariaLabel={`You have ${activityScore} points.`}
            progressBarStyle={progressBarStyle}
            style={style}
            className={classnames(progressBarStyle.base, style.progressBar)}
            bsClass={classnames(progressBarStyle.progressValueBase, style.progressBarValue)}
          />
          <span>
            <span className={style.pointsText}>
              <span className={style.activityScoreValue} data-test-id="progressCurrentScore">{activityScore} pts</span>
            </span>
          </span>
        </Col>
        <Col sm={2} xs={2} className={style.targetScoreContainer}>
          <span className={style.targetScoreText}>
            Target <br /><span
              className={style.targetScoreValue}
              data-test-id="progressTargetScore"
            >{scoreTarget}</span>
          </span>
        </Col>
      </Row>
      {ffEstimatedTimeToCompleteEnabled && courseEstTime > 0 &&
      <Row className={style.estTimeToCompleteRow}>
        <Col xs={12}>
          <p className={style.visuallyHidden}>Estimated Time to Complete:</p>
          <span aria-hidden="true">Est. Time to Complete:</span><span className={style.estTimeToComplete}>{courseEstTime != null ? `${courseEstTime}\u00A0min` : '--'}</span>
        </Col>
        <Col xs={12}>
          <RestrictableButton
            id="howIsCalculatedBtnId"
            clickEventHandler={() => openHowIsCalculatedModal()}
            tabIndex={0}
            dataTestId="howIsCalculatedBtn"
            buttonText="How is this calculated?"
            ariaLabel="How is this calculated?"
            textButton
          />
        </Col>
      </Row>
      }
      {
        completedTimestamp
          ? (
          <Row>
            <Col sm={12} xs={12}>
              <div className={style.textAlignRight}>
                <p className={style.greyLabel}>{'Target Score Reached: '}
                  {moment.utc(completedTimestamp).local().format('ddd, MMM D, h:mma')}</p>
              </div>
            </Col>
          </Row>
            )
          : null
      }
      {completedActivity
        ? (
          <div data-test-id="congratulationsText" className={style.completedText}>
            <span className={style.congratulationText}>Congratulations! </span>
            You've completed the activity.
            <br />
            <span className={style.continueText}>
              But don't stop, you can continue answering questions for practice.
            </span>
          </div>
          )
        : null
      }
    </div>
  )
}

ProgressArea.propTypes = {
  completedTimestamp: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  activityScore: PropTypes.number.isRequired,
  scoreTarget: PropTypes.number.isRequired,
  ffEstimatedTimeToCompleteEnabled: PropTypes.bool,
  courseEstTime: PropTypes.number,
  courseAvgTime: PropTypes.number,
  openHowIsCalculatedModal: PropTypes.func
}

export default ProgressArea
